import * as React from "react";
import IProfileSubmenu, { TProfileSubmenu } from "./IProfileSubmenu";
import Submenu from "@appComponents/Submenu/Submenu";
import PortalRender from "@appComponents/PortalRender/PortalRender";
import { NavLink } from "react-router-dom";
import { classNames as cn } from "@features/utils/reactFunctions";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import * as style from "./ProfileSubmenuStyle.module.scss"

// TODO: Probably we can remove all dropdown relations
export class ProfileSubmenu extends React.Component<
  IProfileSubmenu,
  TProfileSubmenu
> {
  state: TProfileSubmenu = {
    open: false,
    dropdown_status: false,
    locationHash: window.location.hash,
    locationString: window.location.pathname,
  };

  openDropdown = () => {
    this.setState({
      dropdown_status: !this.state.dropdown_status,
    });
  };

  componentDidMount() {
    this.changeLocationHash();
  }

  changeLocationHash = () => {
    this.setState({
      dropdown_status: false,
      open: false,
    });
    setTimeout(() => {
      if (this.state.locationHash !== window.location.hash) {
        this.setState({ locationHash: window.location.hash });
      }
    }, 100);
  };

  closeSubmenu = (): void => {
    if (this.state.open) this.setState({ open: false });
  };

  renderMenu = () => {
    return this.props.menu.map((link, index) => {
      const dropdownParentClass =
        link.children && this.state.dropdown_status ? style.dropdownParent : "";

      return (
        !link.hide && (
          <li className={style.menuItem} key={index}>
            <NavLink
              className={cn(style.link, dropdownParentClass)}
              activeClassName={style.linkActive}
              to={
                link.hash === "#account" &&
                !this.props.profile.connectedWithIdentity
                  ? ""
                  : link.url
              }
              key={index}
              onClick={this.closeSubmenu}
              target={link.url === "/users/sign_out" ? "_self" : ""}
              data-cy={`profile-link-${link.label}`}
            >
              {link.hash === "#membership"
                ? this.props.bitcoinJourneyStep > 0
                  ? link.label
                  : "Start Here"
                : link.label}
              <i
                className={style.icon}
                dangerouslySetInnerHTML={{ __html: link.icon }}
              />
            </NavLink>
          </li>
        )
      );
    });
  };

  render() {
    const { menu, profile } = this.props;

    return (
      <PortalRender portalId="submenu-container">
        <Submenu>
          <div className={cn(style.profileSubmenu, style.newProfileSubmenu)}>
            <ul
              className={cn(
                style.profileMenu,
                this.state.open ? style.profileMenuOpen : null,
                style.newProfileMenu
              )}
            >
              {menu.length > 0 && this.renderMenu()}
            </ul>
            <div
              id="j-toggle-btn"
              className={[
                style.linksToogle,
                this.state.open ? style.linksToogleOpen : null,
              ].join(" ")}
              onClick={() => {
                this.setState({ open: !this.state.open });
              }}
              data-cy="profile-toggle-button"
            />
          </div>
        </Submenu>
      </PortalRender>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    bitcoinJourneyStep: store.userInfo.bitcoin_journey_step ?? 0,
  };
};

export default connect(mapStateToProps)(ProfileSubmenu);
